import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod/v4"

import { SignIn } from "#pages/login/sign-in.tsx"

const searchSchema = z.object({
  redirect: z.string().optional(),
  email: z.string().optional(),
})

export const Route = createFileRoute("/_auth/sign-in")({
  staticData: { title: "Sign In" },
  validateSearch: searchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: search.redirect ?? "/" })
    }
  },
  component: SignIn,
})
